<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :class="['dot-grid-pattern pointer-events-none select-none', $attrs.class]"
        aria-hidden="true"
        :style="`--dot-size: ${size}px;`"
        preserveAspectRatio="xMidYMid slice"
    >
        <defs>
            <pattern
                :id="patternId"
                :width="spacing"
                :height="spacing"
                patternUnits="userSpaceOnUse"
            >
                <circle :cx="spacing / 2" :cy="spacing / 2" :r="size" fill="currentColor" />
            </pattern>
        </defs>
        <rect width="100%" height="100%" :fill="`url(#${patternId})`" />
    </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineProps({
    spacing: { type: Number, default: 24 },
    size: { type: Number, default: 1.5 },
});

// Each instance needs a unique pattern id so multiple dot-grids can coexist on one page.
const uid = Math.random().toString(36).slice(2, 9);
const patternId = computed(() => `dot-grid-${uid}`);
</script>
